import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { CalendarClock } from "lucide-react";

const importanceColor = (imp) => (imp === "high" ? "#ef4444" : imp === "med" ? "#f59e0b" : "#6b7280");

const formatCountdown = (iso) => {
  if (!iso) return "—";
  const diffMs = new Date(iso).getTime() - Date.now();
  if (diffMs < 0) return "past";
  const mins = Math.floor(diffMs / 60000);
  if (mins < 60) return `${mins}m`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ${mins % 60}m`;
  return `${Math.floor(hours / 24)}d ${hours % 24}h`;
};

export default function NewsWidget() {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    const load = () => api.get("/news/upcoming?days=7").then((r) => setEvents(r.data.events || [])).catch(() => {});
    load();
    const iv = setInterval(load, 60000);
    return () => clearInterval(iv);
  }, []);

  const top3 = events.filter((e) => new Date(e.scheduled_at) > new Date()).slice(0, 3);

  return (
    <div className="vx-card" data-testid="news-widget">
      <div className="px-5 py-3 border-b border-[#1f2937] flex items-center justify-between">
        <div className="vx-label">Upcoming News</div>
        <CalendarClock className="w-3.5 h-3.5 text-[#f59e0b]" />
      </div>
      <div className="divide-y divide-[#1f2937]">
        {top3.length === 0 ? (
          <div className="px-5 py-6 text-center text-xs text-[#6b7280] font-mono">No upcoming events</div>
        ) : top3.map((e) => (
          <div key={e.id} className="px-5 py-3 flex items-center justify-between text-xs">
            <div className="min-w-0 pr-3">
              <div className="font-semibold truncate" title={e.event_name}>{e.event_name}</div>
              <div className="text-[10px] text-[#6b7280] font-mono flex items-center gap-2">
                <span
                  className="px-1.5 py-0.5 rounded font-bold border"
                  style={{ borderColor: importanceColor(e.importance), color: importanceColor(e.importance) }}
                >
                  {e.currency}
                </span>
                <span className="uppercase tracking-wider">{e.importance}</span>
              </div>
            </div>
            <div className="text-right shrink-0">
              <div className="font-mono font-semibold text-[#f59e0b]">{formatCountdown(e.scheduled_at)}</div>
              <div className="text-[9px] text-[#6b7280] font-mono">
                {new Date(e.scheduled_at).toLocaleDateString([], { month: "short", day: "numeric" })}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
